/*
 * @Author: YuanYuan
 * @Date: 2024-06-05 17:55:15
 * @LastEditTime: 2025-05-20 14:04:22
 * @Description: 任务管理接口集合
 */
const prefix = process.env.VUE_APP_API_PREFIX

export default [
  {
    name: 'tableQuery',
    path: `${prefix}/cacheRefresh/getTaskList`,
    method: 'get',
    params: {
      page: 1,
      limit: 10,
      time: '',
      url: '',
      status: '',
      type: ''
    },
    desc: '任务列表'
  },
  {
    name: 'maxUrlCount',
    path: `${prefix}/cacheRefresh/countUrlDir`,
    method: 'get',
    params: {},
    desc: '可以推送的最大值'
  },
  {
    name: 'commonUrlList',
    path: `${prefix}/cacheRefresh/getCommonContent`,
    method: 'get',
    params: {
      type: ''
    },
    desc: '获取常用url/目录'
  },
  {
    name: 'commonAdd',
    path: `${prefix}/cacheRefresh/addCommonContent`,
    method: 'post',
    params: {
      type: '',
      content: ''
    },
    desc: '添加常用url/目录'
  },
  {
    name: 'commonDelete',
    path: `${prefix}/cacheRefresh/deleteCommonContent`,
    method: 'post',
    params: {
      type: '',
      content: ''
    },
    desc: '删除常用url/目录'
  },
  {
    name: 'taskAdd',
    path: `${prefix}/cacheRefresh/add`,
    method: 'post',
    params: {
      type: '0',
      content: '',
      taskType: '0',
      delaySecond: 0, // 即时延迟时间(换算成分钟)
      taskName: '', // 预约任务名称
      orderTime: '', // 预约任务日期
      refreshDate: '', // 循环刷新日期
      refreshTime: '', // 循环刷新时间
      frequency: '', // 循环刷新频率
      ignoreCase: '', // 目录刷新转为小写
      fetch: ''
    },
    desc: '创建任务'
  }
]
